import React, { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, MenuItem, Stack, TextField, Typography } from '@mui/material';
import saasApi from '../../utils/saasApi';

export default function SelfServiceCameras() {
  const [branches, setBranches] = useState([]);
  const [cameras, setCameras] = useState([]);
  const [branchId, setBranchId] = useState('');
  const [name, setName] = useState('');
  const [rtspUrl, setRtspUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    Promise.all([saasApi.getBranches(), saasApi.getBillingSetupCameras()])
      .then(([branchRows, cameraResult]) => {
        if (!active) return;
        setBranches(branchRows);
        setCameras(cameraResult.cameras || []);
        setBranchId((current) => current || String(branchRows[0]?.id || ''));
      })
      .catch((err) => { if (active) setError(err.message || 'No se pudieron cargar las cámaras'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const save = async (event) => {
    event.preventDefault();
    if (saving || !name.trim() || !branchId || !/^rtsps?:\/\//i.test(rtspUrl.trim())) return;
    setSaving(true); setError('');
    try {
      const result = await saasApi.createCamera({ name: name.trim(), branch_id: Number(branchId), rtsp_url: rtspUrl.trim() });
      setCameras((current) => [...current, { id: result.id, name: name.trim(), branch_id: Number(branchId), branch_name: branches.find((branch) => String(branch.id) === branchId)?.name }]);
      setName(''); setRtspUrl('');
    } catch (err) { setError(err.message || 'No se pudo registrar la cámara'); }
    finally { setSaving(false); }
  };

  return <Stack component="section" spacing={2} sx={{ maxWidth: 780 }}>
    <Typography variant="h6">Cámaras para la contratación</Typography>
    <Alert severity="info">Registrar una cámara no confirma su conexión ni activa el motor. La URL RTSP se envía únicamente al backend al guardarla y no se muestra después.</Alert>
    {error && <Alert severity="error">{error}</Alert>}
    {loading ? <CircularProgress aria-label="Cargando cámaras" /> : cameras.length
      ? <Stack spacing={1}>{cameras.map((camera) => <Typography key={camera.id}>{camera.display_name || camera.name} · {camera.branch_name || 'Sucursal registrada'}</Typography>)}</Stack>
      : <Typography color="text.secondary">Todavía no hay cámaras registradas.</Typography>}
    <Stack component="form" onSubmit={save} spacing={2}>
      <TextField select required label="Sucursal" value={branchId} onChange={(event) => setBranchId(event.target.value)}>
        {branches.map((branch) => <MenuItem key={branch.id} value={String(branch.id)}>{branch.name}</MenuItem>)}
      </TextField>
      <TextField required label="Nombre de la cámara" value={name} onChange={(event) => setName(event.target.value)} />
      <TextField required label="URL RTSP" type="password" autoComplete="off" value={rtspUrl} onChange={(event) => setRtspUrl(event.target.value)} helperText="Se guarda como credencial; no se vuelve a mostrar." />
      <Button type="submit" variant="contained" disabled={saving || !branches.length || !name.trim() || !/^rtsps?:\/\//i.test(rtspUrl.trim())}>{saving ? 'Guardando…' : 'Registrar cámara'}</Button>
    </Stack>
  </Stack>;
}
